var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{attrs:{"type":"image","max-height":"56px"}})}
var staticRenderFns = []

export { render, staticRenderFns }